import { AUTOMATION_CATEGORY_PRESET_COLORS } from '@reach/shared-types/automation-category';

/** Picks an initial color for category creation in the partner and tenant dashboards. */
export function randomCategoryColor(): string {
  const presetIndex = Math.floor(Math.random() * AUTOMATION_CATEGORY_PRESET_COLORS.length);
  return AUTOMATION_CATEGORY_PRESET_COLORS[presetIndex];
}
